import { Avatar, Paper, Popper, useTheme, AvatarGroup, Box } from "@mui/material";
import { AssigneeDetails } from "./AssigneeDetails";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface User {
  id?: string | number; 
  first_name: string;
  last_name?: string;
  email: string;
  profile_picture_url?: string;
}

interface Props {
  assignees: User[];
}

export const TableRowAssignees: React.FC<Props> = ({ assignees }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [assigneeDetailsOpen, setAssigneeDetailsOpen] = useState(false);
  const stackRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const stackEl = stackRef.current;
    if (!stackEl) return;

    const displayPaperView = () => {
      setAssigneeDetailsOpen(true);
    };

    const hidePaperView = () => {
      setAssigneeDetailsOpen(false);
    };

    stackEl.addEventListener("mouseenter", displayPaperView);
    stackEl.addEventListener("mouseleave", hidePaperView);

    return () => {
      stackEl.removeEventListener("mouseenter", displayPaperView);
      stackEl.removeEventListener("mouseleave", hidePaperView);
    };
  }, []);

  return (
    <>

      <Box 
        ref={stackRef} 
        sx={{ display: "inline-flex", cursor: "pointer", mt: 1 }}
      >
        <AvatarGroup
          max={3} 
          sx={{
            "& .MuiAvatar-root": {
              width: 25,
              height: 25,
              fontSize: "0.75rem",
              border: `1px solid ${theme.palette.background.paper}`,
            },
          }}
        >
          {assignees.map((assignee, index) => (
            <Avatar
              key={assignee.id ?? index}
              alt={`${assignee.first_name} picture`}
              src={assignee.profile_picture_url || undefined}
            >
              {assignee.first_name?.charAt(0).toUpperCase() || "?"}
            </Avatar>
          ))}
        </AvatarGroup>
      </Box>

      <Popper
        open={assigneeDetailsOpen}
        anchorEl={stackRef.current}
        placement="left-end"
        style={{
          zIndex: 1300,
        }}
      >
        <Paper
          elevation={4}
          style={{
            padding: 8,
            width: "190px",
            backgroundColor: colors.primary[900],
            border: `1px solid ${colors.primary[700] || "#444"}`,
          }}
        >
          {assignees.map((assignee, index) => (
            <AssigneeDetails
              key={assignee.id ?? index}
              firstName={assignee.first_name || assignee.email.split("@")[0]}
              lastName={assignee.last_name || ""}
              profileImg={
                assignee.profile_picture_url ||
                assignee.first_name?.charAt(0).toUpperCase() || "?"
              }
            />
          ))}
        </Paper>
      </Popper>
    </>
  );
};

TableRowAssignees.propTypes = {
  assignees: PropTypes.arrayOf(PropTypes.object).isRequired,
};